import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './FlexiPayHistory.html';
import config from "@/settings/config.js";
import _axios from '@/services/axios';
import { FlexiPayBalanceDto } from '../FlexiPayBalance/FlexiPayBalanceDto';
import moment from 'moment';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
})
export default class FlexiPayHistory extends Vue {
  items = [];
  fields = [
    {
      key: "createdOn",
      label: "Time",
    },
    {
      key: "description",
      label: "Description"
    },  
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "fee",
      label: "Fee",
    },
    {
      key: "balance",
      label: "Balance",
    },
  ]

  async mounted() {
    const wallet = this.$route.query.w as string;
    await this.getTransactions(wallet);
  }

  async getTransactions(id: string): Promise<void> {
    try {
      const response = await _axios.get(`${config.gateway}credits/api/FlexiPay/GetTransactions?flexiPayWalletId=${id}`);
      this.items = response.data;
    } catch (err) {
      console.error(err);
    }
  }

  getWithDrawalType(item:any): string
  {
    const description =item.description;
    if(item.withDrawalType=='0')
      return `${description} - Umbai Wallet`;
    if(item.withDrawalType=='1')
      return `${description} - Cash Out`;
    return description;
  }
}
